import React, { useState, useEffect } from 'react';
import classNames from 'classnames';
import './TabPanel.less';

export interface ITabPanelProps extends React.HTMLProps<HTMLDivElement> {
  currentTabId: string | null | undefined;
  tabId: string;
}

export function TabPanel(props: React.PropsWithChildren<ITabPanelProps>) {
  const { children, tabId, currentTabId, className, ...other } = props;
  const isHidden = tabId !== currentTabId;

  const [shouldRender, setShouldRender] = useState(tabId === currentTabId);
  useEffect(() => {
    if (tabId === currentTabId && !shouldRender) {
      setShouldRender(true);
    }
  }, [currentTabId, shouldRender, tabId]);

  return (
    <div
      className={classNames('dpc-tab-panel', className, {
        'dpc-tab-panel--hidden': isHidden,
      })}
      role="tabpanel"
      hidden={isHidden}
      {...other}
    >
      {shouldRender && children}
    </div>
  );
}
